import { RequireOnly } from '@pelicargo/types';
import { modelUtils } from '@pelicargo/utils';
import { AircraftType, Cargo } from '@prisma/client';

export const isOverSizedForAircraftType = (
  cargos: RequireOnly<Cargo, 'length' | 'width' | 'height' | 'weight'>[],
  aircraftType: AircraftType,
) => {
  return cargos?.some((node) => {
    return modelUtils.cargo.isOversizedForAircraftType(node, aircraftType);
  });
};
